/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React, { FC } from 'react';
import { useLinkAnalysisResultsStore } from '../../mothership/linkAnalysisResults.state';

interface Props {
  id: string;
}

export const ResultsLegend: FC<Props> = ({ id }) => {
  const attrId = `${id}Legend`;
  const legend = useLinkAnalysisResultsStore((state) => state.legend);

  return (
    <div
      data-cy={attrId}
      id="linkAnalysisGraphLegend"
      className="linkAnalysisGraphLegend"
    >
      {legend.map((item) => (
        <div
          key={item.value}
          data-cy={item.value}
          className="linkAnalysisGraphLegendItem"
        >
          <div
            className="linkAnalysisGraphLegendItemBullet"
            style={{ backgroundColor: item.color }}
          ></div>
          <div
            className="linkAnalysisGraphLegendItemLabel"
            data-cy={item.label}
          >
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
};
